var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaturesManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 520,
    viewBox: "0 0 800 520",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gm",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#99e0e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#20a4ab"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 520,
    rx: 24,
    fill: "#f8fafc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 660,
    height: 380,
    rx: 18,
    fill: "#fff",
    stroke: "#e5e9f0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 110,
    width: 200,
    height: 14,
    rx: 7,
    fill: "#334155",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 136,
    width: 160,
    height: 10,
    rx: 5,
    fill: "#334155",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 170,
    width: 600,
    height: 70,
    rx: 10,
    fill: "url(#gm)",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 260,
    width: 600,
    height: 70,
    rx: 10,
    fill: "#20a4ab",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 350,
    width: 240,
    height: 40,
    rx: 10,
    fill: "url(#gm)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesManagement);
export default __webpack_public_path__ + "static/media/features-management.bd1c94c8e6c544e7053716e20cf0a721.svg";
export { ForwardRef as ReactComponent };